import BookingsCard from "../../Hospitals/TotalBookings/BookingsCard";
import { useParams } from "react-router-dom";
import { useDoctorAppointments } from "../../../hooks/appointments/useDoctorAppointments";
import SearchDateTable from "../../Tables/SearchDateTable";
// import { formatDate } from "../../configs/formatDate";
import { useState } from "react";
import { getDateFromIso } from "../../configs/getDateFromISO";
import PropTypes from "prop-types";
import StatusBadge from "../../assests/StatusBadge";

function DoctorsBookings(props) {
  const { analytics } = props;
  const { id } = useParams();
  const [query, setQuery] = useState("");

  const handelQuery = (queryResult) => {
    setQuery(queryResult);
  };

  const { data: appointments, isLoading } = useDoctorAppointments(id, query);
  const completed_count = analytics?.booking?.count_completed || 0;
  const remaining_count = analytics?.booking?.count_remaining || 0;

  const bookinsDetails = [
    {
      id: 1,
      bookings: completed_count + remaining_count,
      dueStatus: "",
      operation: "Total Bookings",
    },
    {
      id: 2,
      bookings: remaining_count,
      dueStatus: "",
      operation: "Ongoing Bookings",
    },
    {
      id: 3,
      bookings: completed_count,
      dueStatus: "",
      operation: "Completed Bookings",
    },
  ];
  const columns = [
    {
      title: "Booking Id",
      dataIndex: "booking_id",
      // sorter: (a, b) => a.id - b.id,
    },
    {
      title: "TRANSACTION NAME",
      dataIndex: "transactionName",
      // sorter: (a, b) => a.transactionName.length - b.transactionName.length,
      render: (item, record) => <div>{record.type}</div>,
    },
    {
      title: "BOOKED DATE",
      dataIndex: "createdAt",
      // sorter: (a, b) => a.dueIssue.length - b.dueIssue.length,
      render: (item) => <div>{getDateFromIso(item)}</div>,
    },
    {
      title: "APPOINTMENT DATE",
      dataIndex: "appointmentDate",
      // sorter: (a, b) => a.dueIssue.length - b.dueIssue.length,
      render: (item) => <div>{getDateFromIso(item)}</div>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (item) => (
        <div>
          <StatusBadge status={item} />
        </div>
      ),
    },
    {
      title: <div className="d-flex justify-content-center">AMOUNT</div>,
      dataIndex: "amount",
      // sorter: (a, b) => a.amount.length - b.amount.length,
      render: (item) => (
        <div className="d-flex justify-content-center">${item ?? 0}</div>
      ),
    },
    // {
    //   title:<div className="d-flex justify-content-center">ACTIONS</div>,
    //   dataIndex: "prescriptionUrl",
    //   render:(item)=>(
    //     <div>
    //       {item && <a className="d-flex justify-content-center" href={item} target="_blank" rel="noopener noreferrer">view</a>}
    //     </div>
    //   )
    // },
  ];
  return (
    <div>
      <div className="row ">
        {bookinsDetails.map((item) => (
          <div
            key={item.id + item.operation}
            className="col-md-4 col-sm-6 col-lg-4 col-xl-4"
          >
            <BookingsCard data={item} />
          </div>
        ))}
      </div>

      <SearchDateTable
        data={appointments}
        isLoading={isLoading}
        handelQuery={handelQuery}
        columns={columns}
        title="Bookings"
      />
    </div>
  );
}

// props validation
DoctorsBookings.propTypes = {
  analytics: PropTypes.object.isRequired,
};

export default DoctorsBookings;
